import { Component, Inject, TemplateRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorDialogDataI } from '@interfaces/error-dialog-data.interface';
import { MessageVarsT } from '@interfaces/message-vars.type';

@Component({
  selector: 'app-error-alert-dialog',
  templateUrl: './error-alert-dialog.component.html',
  styleUrls: ['./error-alert-dialog.component.scss'],
})
export class ErrorAlertDialogComponent {
  public message!: string;
  public stackTrace?: string;
  public headerLabel!: string;
  public closeLabel!: string;
  public template?: TemplateRef<any>;
  public extraText?: string;
  public extraTextList?: string[];
  public messageVars?: MessageVarsT;

  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA)
    public data: string | ErrorDialogDataI
  ) {
    if (typeof this.data === 'string') {
      this.message = this.data;
    } else {
      this.message = this.data.message;
      if (this.data.stackTrace) {
        this.stackTrace = this.data.stackTrace;
      }
      if (this.data.extraText) {
        this.extraText = this.data.extraText;
      }
      if (this.data.extraTextList) {
        this.extraTextList = this.data.extraTextList;
      }
      if (this.data.messageVars) {
        this.messageVars = this.data.messageVars;
      }
    }
  }

  public close() {
    this.dialogRef.close(true);
  }
}
